export function runRequests(requests, { intervalInMs = 500, gameState, stateMachine, isAgentPaused, setIsAgentTakingMove, }) {
    return new Promise((resolve, reject) => {
        if (!requests.getCount()) {
            setIsAgentTakingMove(false);
            resolve(false);
            return;
        }
        let nextState = JSON.parse(JSON.stringify(gameState));
        const intervalId = setInterval(() => {
            function finish() {
                clearInterval(intervalId);
                setIsAgentTakingMove(false);
                resolve(true);
            }
            if (isAgentPaused()) {
                return;
            }
            const request = requests.takeNextAgentRequest();
            if (request === undefined) {
                finish();
                return;
            }
            try {
                nextState = stateMachine.executeRequest(request, nextState);
            }
            catch (e) {
                clearInterval(intervalId);
                setIsAgentTakingMove(false);
                reject(e);
            }
            if (requests.getCount() === 0 || nextState.stateName === 'gameOver') {
                finish();
            }
        }, intervalInMs);
    });
}
export function runRequestsSync(requests, { gameState, stateMachine, setIsAgentTakingMove, }) {
    if (!requests.length) {
        setIsAgentTakingMove(false);
        return false;
    }
    let nextState = JSON.parse(JSON.stringify(gameState));
    while (requests.length) {
        const request = requests.shift();
        try {
            nextState = stateMachine.executeRequest(request, nextState);
        }
        catch (e) {
            setIsAgentTakingMove(false);
            throw e;
        }
        if (requests.length === 0 || nextState.stateName === 'gameOver') {
            setIsAgentTakingMove(false);
        }
    }
    return true;
}
